import { createAction } from '@reduxjs/toolkit';

import type { LanguageEnum } from 'js/src/client';
import { DOCUMENT_ACTIONS } from 'js/src/data/document/document-types';

export const storeDocumentId = createAction<{
    documentId: number;
    systemTriggered: boolean;
    parentActionGroup: string | undefined;
}>(DOCUMENT_ACTIONS.STORE_DOCUMENT_ID);

export const storeDocumentName = createAction<{
    documentName: string;
    systemTriggered: boolean;
    parentActionGroup: string | undefined;
}>(DOCUMENT_ACTIONS.STORE_DOCUMENT_NAME);

export const storeDocumentUrl = createAction<{
    documentUrl: string;
    systemTriggered: boolean;
    parentActionGroup: string | undefined;
}>(DOCUMENT_ACTIONS.STORE_DOCUMENT_URL);

export const storeDocumentLanguageCode = createAction<{
    documentLanguageCode: LanguageEnum;
    systemTriggered: boolean;
    parentActionGroup: string | undefined;
}>(DOCUMENT_ACTIONS.STORE_DOCUMENT_LANGUAGE_CODE);
